// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2fTk_","upload":"Small_upload__3Jf0M","imageWrap":"Small_imageWrap__2ngom","removeBtn":"Small_removeBtn__25-bU"};